import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MenuItem, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { CustomStudioFieldName, Franchise, Project, Transaction } from '../../../core/store/models';
import { HeaderField } from '../../../core/store/types';
import { exportCSV } from '../../../shared/services/csv.service';

@Component({
    selector: 'ah-transaction-table',
    templateUrl: './transaction-table.component.html',
    styleUrls: ['./transaction-table.component.scss'],
    standalone: false
})
export class TransactionTableComponent implements OnChanges, OnInit {
    @Input() customFieldNames?: CustomStudioFieldName;
    @Input() extraBulkOptions?: MenuItem[];
    @Input() fields: string[];
    @Input() franchiseEnts: { [id: number]: Franchise };
    @Input() projectEnts: { [id: number]: Project };
    @Input() selectedRows: any[];
    @Input() transactions: Transaction[];
    @Output() onSelectFields = new EventEmitter();
    @Output() onSelectRows = new EventEmitter();
    @ViewChild('tt', { static: true }) table: Table;

    exportOption: MenuItem = {
        label: 'Export to CSV',
        command: () => {
            this.exportToCSVService(this.fieldHeaderFields, this.selectedRows, 'asset transactions');
        }
    };

    bulkOptions: MenuItem[] = [];
    cols: SelectItem[] = [];
    fieldHeaderFields: HeaderField[] = [];
    rows: any[] = [];
    exportToCSVService = exportCSV;

    constructor(public dialog: MatDialog) { }

    ngOnInit() {
        if (this.extraBulkOptions) {
            this.bulkOptions = [...this.extraBulkOptions, this.exportOption];
        } else {
            this.bulkOptions = [this.exportOption];
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.transactions && changes.transactions.currentValue) {
            const { cols, rows } = Transaction.getOriginalData(changes.transactions.currentValue, this.customFieldNames, this.franchiseEnts, this.projectEnts);
            this.cols = cols;
            this.rows = rows;
            this.addExtraFieldsToCols();
        } else if (changes.fields && changes.fields.currentValue) {
            this.addExtraFieldsToCols();
        }

        if (changes.fields && changes.fields.currentValue) {
            // replace periods with underscores because turbotable
            // assumes periods in fields indicate subobjects
            // when exporting to csv [ch10667]
            this.fieldHeaderFields = changes.fields.currentValue.map(f => ({
                canonical_name: f.replace(/\./g, '_'),
                name: f
            }));
        }
    }

    addExtraFieldsToCols() {
        this.fields.forEach(field => {
            if (!this.cols.find(col => col.value === field)) {
                this.cols.push({
                    label: field,
                    value: field
                });
            }
        });
    }

    isChecked(row: any) {
        return !!this.selectedRows.find(r => r.id === row.id);
    }

    onColReorder($event: { columns: HeaderField[] }) {
        this.onSelectFields.emit($event.columns.map(c => c.canonical_name));
    }

    onSelectAll() {
        if (this.selectedRows.length === this.rows.length) {
            this.onSelectRows.emit([]);
        } else {
            this.onSelectRows.emit(this.rows.slice());
        }
    }

    onSelectColumns($event: { value: string[] }) {
        this.onSelectFields.emit($event.value);
    }

    onSelectRowCheckbox(row: any) {
        const selectedRows = [...this.selectedRows];
        const i = selectedRows.findIndex(r => r.id === row.id);
        if (i > -1) {
            selectedRows.splice(i, 1);
        } else {
            selectedRows.push(row);
        }
        this.onSelectRows.emit(selectedRows);
    }
}
